export function CardSkeleton() {
  return (
    <div className="card animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-3"></div>
          <div className="flex items-center gap-4 mb-2">
            <div className="h-6 bg-gray-200 rounded-full w-20"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="h-3 bg-gray-200 rounded w-32 mt-2"></div>
        </div>
        <div className="ml-4">
          <div className="h-10 bg-gray-200 rounded-lg w-28"></div>
        </div>
      </div>
    </div>
  );
}

export function PatientCardSkeleton() {
  return <CardSkeleton />;
}

export function AlertCardSkeleton() {
  return (
    <div className="card border-2 border-gray-200 animate-pulse">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="h-6 bg-gray-200 rounded w-2/3 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-3"></div>
          <div className="h-3 bg-gray-200 rounded w-1/3 mb-2"></div>
          <div className="h-6 bg-gray-200 rounded-full w-16 mt-3"></div>
        </div>
        <div className="ml-4">
          <div className="h-9 bg-gray-200 rounded-lg w-24"></div>
        </div>
      </div>
    </div>
  );
}

export function SkeletonList({ count = 3, type = 'patient' }: { count?: number; type?: 'patient' | 'alert' }) {
  const SkeletonComponent = type === 'patient' ? PatientCardSkeleton : AlertCardSkeleton;
  
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonComponent key={i} />
      ))}
    </div>
  );
}
